import { Field, Form, Formik } from "formik";
import { Alert, Button, Modal } from "react-bootstrap";
import util from "../../../utiles/miniUtiles";
import ErrorBox from "../shared/ErrorBox";
import MaskedInput from "react-text-mask";
import { useState } from "react";
import Swal from "sweetalert2";


interface NewSubscriberModalProps {
    show: boolean;
    handleClose: () => void;
}

const NewSubscriberModal: React.FC<NewSubscriberModalProps> = ({ show, handleClose }) => {

    const [loading, setLoading] = useState(false);


    const submitForm = async (values: any) => {
        console.log(values);
        try {
            setLoading(true);
            const request = await util.axios.post(`/account/add_subscriber`, { ...values });
            const { error, msg } = request.data;
            if (error) throw msg;
            setLoading(false);
            Swal.fire('Success', msg, 'success');
        } catch (error) {
            setLoading(false);
            util.handleError(error);
        }
    }

    const phoneNumberMask = ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
    const zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];


    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Register a new Subscriber</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="warning" >
                        <p>This subscriber will not have a subscription id until they have been assigned manually.</p>
                        <p>If we dont create a subscription ID, it will be using the app for free.</p>
                    </Alert>
                    <Formik
                        initialValues={util.initialValues}
                        validationSchema={util.SignupSchema}
                        onSubmit={async (values) => {
                            await submitForm(values)
                        }}
                    >
                        {({
                            errors,
                            touched,
                            handleChange,
                            handleSubmit,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                {/* Form fields */}
                                <div className="container pt-3">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div><label htmlFor="firstNameId">First Name</label></div>
                                            <div><Field type="firstName" id="firstNameId" name="firstName" className="form-control" /></div>
                                            <ErrorBox errors={errors} touched={touched} field="firstName" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="lastNameId">Last Name</label></div>
                                            <div><Field type="lastName" id="lastNameId" name="lastName" className="form-control" /></div>
                                            <ErrorBox errors={errors} touched={touched} field="lastName" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="emailId">Email</label></div>
                                            <div>
                                                <Field
                                                    //     // onBlur={async (e: any) => {
                                                    //     // await validateEmail(e, true)
                                                    // }}
                                                    type="email"
                                                    id="emailId"
                                                    name="email"
                                                    className="form-control"
                                                />
                                            </div>
                                            <span className="d-none formError" id="emailInvalidChars"></span>
                                            <ErrorBox errors={errors} touched={touched} field="email" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="phoneNumberId">Phone Number</label></div>
                                            <div>
                                                <Field name="phoneNumber">
                                                    {
                                                        ({ field }: { field: any }) => <MaskedInput
                                                            {...field}
                                                            type="text"
                                                            id="phoneNumberId"
                                                            mask={phoneNumberMask}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                        />
                                                    }
                                                </Field>
                                                <ErrorBox errors={errors} touched={touched} field="phoneNumber" />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div><label htmlFor="addressId">Address</label></div>
                                            <div><Field type="address" id="addressId" name="address" className="form-control" /></div>
                                            <ErrorBox errors={errors} touched={touched} field="address" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="countryId">Country</label></div>
                                            <div>
                                                <Field as="select" type="country" id="countryId" name="country" className="form-control">
                                                    <option value=""> -- </option>
                                                    <option value="USA">USA</option>
                                                </Field>
                                            </div>
                                            <ErrorBox errors={errors} touched={touched} field="country" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="stateId">State</label></div>
                                            <div>
                                                <Field as="select" type="state" id="stateId" name="state" className="form-control">
                                                    <option value=""> -- </option>
                                                    {
                                                        util.USA_STATES.map((item, index) => <option key={index} value={item.abbreviation}>{item.name}</option>)
                                                    }
                                                </Field>

                                            </div>
                                            <ErrorBox errors={errors} touched={touched} field="state" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="cityId">City</label></div>
                                            <div><Field type="city" id="cityId" name="city" className="form-control" /></div>
                                            <ErrorBox errors={errors} touched={touched} field="city" />
                                        </div>
                                        <div className="col-md-6">
                                            <div><label htmlFor="zipId">Zip</label></div>
                                            <div>
                                                <Field name="zip">
                                                    {
                                                        ({ field }: { field: any }) => <MaskedInput
                                                            {...field}
                                                            type="text"
                                                            mask={zipMask}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                        />
                                                    }
                                                </Field>
                                            </div>
                                            <ErrorBox errors={errors} touched={touched} field="zip" />
                                        </div>

                                    </div>
                                </div>
                                {/* Submit button */}
                                <Modal.Footer className="mt-3">
                                    <Button variant="secondary" onClick={handleClose}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="primary">Create Subscriber</Button>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal >
            {util.LOADING_SCREEN(loading)}
        </>
    );
}

export default NewSubscriberModal;